<div class="relative p-4">
  <div
    class="sticky top-0 z-20 flex w-full flex-row gap-4 border-b-1 border-gray-800 bg-white pb-4">
    <div class="cursor-pointer bg-gray-50 p-4" (click)="toggle()">
      @if (form.disabled) {
        ENABLE
      } @else {
        DISABLE
      }
    </div>
    <div class="cursor-pointer bg-gray-50 p-4" (click)="toggleContext()">
      @if (siteContextService.getContext() === 'shop') {
        Wechsel zu CMS Inputs
      } @else {
        Wechsel zu Shop Inputs
      }
    </div>
  </div>

  <div class="flex flex-col gap-5 pt-24">
    <div class="py-2">Pflichtfeld</div>
    <aw-text-input
      [formControl]="text"
      label="Text Input"
      id="textInput1"
      placeholder="test">
      <div>Here be Errors for Text Input</div>
    </aw-text-input>

    <div class="flex w-full flex-col gap-5" [formGroup]="form">
      <div class="flex flex-row gap-2">
        <aw-toggle formControlName="toggle" label="Toggle" id="toggle">
          <div>Here be Errors for Toggle</div>
        </aw-toggle>
        <aw-toggle formControlName="toggleDisabled" label="Toggle Disabled" id="toggleDisabled">
        </aw-toggle>
      </div>
      <aw-text-input formControlName="text" label="Text Input" id="textInput">
        <div>Here be Errors for Text Input</div>
      </aw-text-input>
      <div class="py-2">Pflichtfeld</div>
      <aw-password-input
        formControlName="password"
        label="Password Input"
        id="passwordInput">
        <div>Here be Errors for Password</div>
      </aw-password-input>
      <div class="py-2">Pflichtfeld, Mindestlänge 10 Zeichen</div>
      <aw-text-area
        formControlName="textArea"
        label="Text Area"
        id="textAreaInput">
        <div>Here be Errors for TextArea</div>
      </aw-text-area>
      <div class="py-2">Pflichtfeld</div>

      <div class="py-2">Pflichtfeld, mindestens 1, höchstens 10</div>
      <aw-number-input
        formControlName="number"
        label="Number input"
        id="numberInput"
        ><div>Here be Errors for Number</div></aw-number-input
      >
      <div class="py-2">Pflichtfeld</div>
      <aw-checkbox formControlName="checkBox" label="Checkbox" id="checkBox">
        <div>Here be Errors for Checkbox</div>
      </aw-checkbox>
      <div class="py-2">Pflichtfeld</div>

      <aw-date-input
        formControlName="date"
        label="DateInput"
        id="dateInputNew"
        [showTimePicker]="false">
        <div>Here be Errors for Date Input</div>
      </aw-date-input>

      <aw-date-input
        formControlName="dateTime"
        label="DateTimeInput"
        id="dateTimeInputNew"
        [showTimePicker]="true">
        <div>Here be Errors for Date Input</div>
      </aw-date-input>
      <aw-relation-date-input
        headline="Fancy Datepicker"
        label="FancyDateTimeInput"
        id="fancyDateTimeInputNew"
        [arrivalControl]="form.controls['arrival'] | toFormControl"
        [departureControl]="form.controls['departure'] | toFormControl"
        [showTimePicker]="true">
        <div>Here be Errors for Date Input</div>
      </aw-relation-date-input>
      <div class="py-2">Pflichtfeld, mindestens 5</div>
      <aw-drop-down
        formControlName="dropdown"
        label="Drop Down"
        id="dropdown"
        [options]="[1, 2, 3, 4, 5, 6, 7]">
        <div>Here be Errors for Drop Down</div>
      </aw-drop-down>
      <aw-drop-down
        formControlName="dropdownName"
        label="Drop Down Name"
        name="name"
        id="dropdown2"
        [options]="[
          { value: 1, name: 'option 1' },
          { value: 2, name: 'option 2' },
          { value: 3, name: 'option 3' },
          { value: 4, name: 'special option 4' },
          { value: 5, name: 'option 5' },
          { value: 6, name: 'special option 6' },
          { value: 7, name: 'option 7' },
          { value: 8, name: 'The last one' },
        ]">
        <div>Here be Errors for Drop Down</div>
      </aw-drop-down>
      <aw-drop-down
        formControlName="dropdownNameAndValue"
        label="Drop Down Name and Value"
        name="name"
        valueAttribute="value"
        id="dropdown3"
        [options]="[
          { value: 1, name: 'option 1' },
          { value: 2, name: 'option 2' },
          { value: 3, name: 'option 3' },
          { value: 4, name: 'special option 4' },
          { value: 5, name: 'option 5' },
          { value: 6, name: 'special option 6' },
          { value: 7, name: 'option 7' },
          { value: 8, name: 'The last one' },
        ]">
        <div>Here be Errors for Drop Down</div>
      </aw-drop-down>
      <aw-drop-down
        formControlName="dropdownSearchable"
        label="Drop Down Searchable"
        name="name"
        valueAttribute="value"
        id="dropdown4"
        [searchable]="true"
        [options]="[
          { value: 1, name: 'option 1' },
          { value: 2, name: 'option 2' },
          { value: 3, name: 'option 3' },
          { value: 4, name: 'special option 4' },
          { value: 5, name: 'option 5' },
          { value: 6, name: 'special option 6' },
          { value: 7, name: 'option 7' },
          { value: 8, name: 'The last one' },
        ]">
        <div>Here be Errors for Drop Down</div>
      </aw-drop-down>

      <div class="flex flex-row gap-2">
        <aw-single-select
          formControlName="singleSelect"
          label="Single Select"
          id="single-select1"
          [options]="[1, 2, 3, 4, 5, 6, 7]">
          <div>Here be Errors for the Single Select</div>
        </aw-single-select>
        <aw-single-select
          formControlName="singleSelect3"
          id="single-select3"
          [options]="[1, 2, 3, 4, 5, 6, 7]">
          <div>Here be Errors for the Single Select</div>
        </aw-single-select>
        <aw-single-select
          formControlName="singleSelect2"
          id="single-select2"
          [hasBorder]="true"
          [options]="[1, 2, 3, 4, 5, 6, 7]">
          <div>Here be Errors for the Single Select</div>
        </aw-single-select>
        <aw-single-select
          formControlName="singleSelect4"
          id="single-select4"
          [hasBorder]="true"
          [options]="[1, 2, 3, 4, 5, 6, 7]">
          <div>Here be Errors for the Single Select</div>
        </aw-single-select>
      </div>

      <div class="py-2">Pflichtfeld, wähle mindestens zwei Optionen</div>
      <aw-multi-select
        formControlName="multiSelect"
        label="Multi Select"
        id="multi-select"
        [options]="[1, 2, 3, 4, 5, 6, 7]">
        <div>Here be Errors for the Multi Select</div></aw-multi-select
      >
      <div class="py-2">Pflichtfeld, wähle mindestens zwei Optionen</div>
      <aw-multi-select
        formControlName="multiSelectObject"
        label="Multi Select"
        name="name"
        id="multi-select-object"
        [options]="[
          { name: 'Test1' },
          { name: 'Test2' },
          { name: 'Test3' },
          { name: 'Test4' },
          { name: 'Test5' },
          { name: 'Test6' },
          { name: 'Test7' },
          { name: 'Test8' },
          { name: 'Test9' },
        ]">
        <div>Here be Errors for the Multi Select</div></aw-multi-select
      >
      <div class="py-2 font-medium">Multi-Select-Dropdown</div>
      <aw-multi-select-drop-down
        formControlName="multiSelectDropDown"
        label="Multi-Select ohne Suche"
        id="multi-select-drop-down"
        [options]="['Option 1', 'Option 2', 'Option 3', 'Option 4', 'Option 5']" />
      <aw-multi-select-drop-down
        formControlName="searchableMultiSelectDropDown"
        label="Multi-Select mit Suche"
        id="searchable-multi-select-drop-down"
        [searchable]="true"
        [options]="[
          'Option 1',
          'Option 2',
          'Option 3',
          'Option 4',
          'Option 5',
          'Option 6',
          'Option 7',
          'Option 8',
        ]" />
      <div class="py-2 font-medium">Listen-Komponenten</div>
      <aw-list-input
        formControlName="textList"
        label="Liste aus Texten mit bis zu 7 Einträgen"
        id="text-list-input"
        itemType="text" />
      <aw-list-input
        formControlName="searchableTextList"
        label="Liste aus Texten mit mehr als 7 Einträgen"
        id="searchable-text-list-input"
        [searchable]="true" />
      <div class="py-2">Pflichtfeld, mindestens 5</div>
      <aw-auto-complete
        label="Auto Complete Simple"
        id="auto-complete-1"
        formControlName="autoComplete"
        [options]="[1, 2, 3, 4, 5, 6, 7, 8]"
        ><div>Here be Errors for the Auto Complete</div></aw-auto-complete
      >
      <div class="py-2">Pflichtfeld, mindestens 5</div>
      <aw-auto-complete
        label="Auto Complete Name & Value"
        id="auto-complete-2"
        formControlName="autoComplete2"
        name="name"
        valueAttribute="value"
        [options]="[
          { value: 1, name: 'option 1' },
          { value: 2, name: 'option 2' },
          { value: 3, name: 'option 3' },
          { value: 4, name: 'special option 4' },
          { value: 5, name: 'option 5' },
          { value: 6, name: 'special option 6' },
          { value: 7, name: 'option 7' },
          { value: 8, name: 'The last one' },
        ]"
        ><div>Here be Errors for the Auto Complete</div></aw-auto-complete
      >
      <div class="py-2">Pflichtfeld</div>
      <aw-auto-complete
        label="Auto Complete Name only"
        id="auto-complete-3"
        formControlName="autoComplete3"
        name="name"
        [options]="[
          { value: 1, name: 'option 1' },
          { value: 2, name: 'option 2' },
          { value: 3, name: 'option 3' },
          { value: 4, name: 'special option 4' },
          { value: 5, name: 'option 5' },
          { value: 6, name: 'special option 6' },
          { value: 7, name: 'option 7' },
          { value: 8, name: 'The last one' },
        ]"
        ><div>Here be Errors for the Auto Complete</div></aw-auto-complete
      >
      <aw-drag-drop
        [allowedFileTypes]="['jpg', 'jpeg', 'png', 'tiff']"
        [fileType]="'image'"
        [isMultiple]="true"
        formControlName="fileUpload"
        label="File Upload"
        id="fileUpload">
        <div>Here be Errors for the File Upload</div>
      </aw-drag-drop>
      @if (!showCorporateDesign()) {
        <aw-icon-picker
          label="Icon Picker Simple"
          id="icon-picker"
          formControlName="iconPicker"
          ><div>Here be Errors for the Icon Picker</div></aw-icon-picker
        >
        <aw-accessibility-text-input
          formControlName="accessibilityText"
          label="Text Input"
          id="accessibilityTextInput">
          <div>Here be Errors for Text Input</div>
        </aw-accessibility-text-input>
        <aw-image-select
          id="imageSelect"
          [usageLabel]="'header.bannerImage'"
          [persistUsageOnSelect]="true"
          formControlName="imageSelect"
          label="Banner" />
        <aw-payment-select
          id="paymentSelect"
          formControlName="paymentSelect"
          label="Payment" />
        <div class="py-2">Pflichtfeld, mindestens 5</div>
        <aw-color-picker-input
          formControlName="color"
          label="Color Input"
          id="color"></aw-color-picker-input>
        <aw-button-group
          class="flex"
          formControlName="primaryFontColor"
          [id]="'primaryFontColor'"
          [options]="[custom, white, black] | enumToButtonOptionArray" />
        <quill-view
          [content]="form.controls['quill'].value"
          format="json"
          theme="snow"></quill-view>
        <aw-text-editor
          formControlName="quill"
          label="Text Editor"
          id="textEditorInput">
          <div>Here be Errors for TextEditor</div>
        </aw-text-editor>
        <aw-language-switcher
          id="language"
          formControlName="language"></aw-language-switcher>
        <aw-translation-text-input
          formControlName="translationText"
          label="Text Area"
          [entityType]="EntityType.test"
          [relationType]="TextRelationType.register"
          id="translationTextInput"
          >Fehler</aw-translation-text-input
        >
        <aw-translation-accessibility-text-input
          formControlName="translationArea"
          label="Text Area"
          [entityType]="EntityType.test"
          [relationType]="TextRelationType.register"
          id="translationAreaInput"
          >Fehler</aw-translation-accessibility-text-input
        >
        <aw-translation-text-area
          formControlName="translationAccessible"
          label="Text Area"
          [entityType]="EntityType.test"
          [relationType]="TextRelationType.register"
          id="translationAcessibleInput"
          >Fehler</aw-translation-text-area
        >
        <aw-translation-text-editor
          formControlName="translationEditorAccessible"
          label="Text Editor"
          [entityType]="EntityType.test"
          [relationType]="TextRelationType.register"
          id="translationEditorAccessible"></aw-translation-text-editor>
      }
    </div>
    {{ form.value | json }}
  </div>
</div>
